import { z } from "zod";

export const nullableString = z.literal("").nullable();

export const nullishString = z.literal("").nullish();
